import React from "react";
import PropTypes from "prop-types";
import Icon from "../icon";

const propTypes = {
  viewIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  side: PropTypes.string,
};

const defaultProps = {
  side: "right",
};

const ViewChanger = ({ viewIndex, onClick, side }) => {
  const isDisabled = () =>
    (side === "right" && viewIndex === 3) ||
    (side === "left" && viewIndex === 0);

  return (
    <div className="flex-grow max-w-12 hidden md:flex items-center">
      <button
        className="bg-white rounded-full h-12 w-12 flex justify-center shadow-md items-center disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none"
        disabled={isDisabled()}
        onClick={() => onClick()}
      >
        <Icon
          className={side === "left" ? "transform rotate-180" : ""}
          iconName="Arrow"
        />
      </button>
    </div>
  );
};

ViewChanger.propTypes = propTypes;

ViewChanger.defaultProps = defaultProps;

export default ViewChanger;
